import {Button, Form, Input, message, Modal, Select, Space, Table} from "antd";
import React, {useEffect, useState} from "react";
import {HttpService} from "../../../services/http/Http.service";
import {HttpErrorService} from "../../../services/http/HttpError.service";
import {Ruolo, SpringPageable, Utente} from "../../../model/models";
import {DeleteOutlined, EditOutlined, PlusOutlined} from "@ant-design/icons";
import ConfirmModal from "../../../components/confirmModal/ConfirmModal";

export default function Users() {

    const [listOfUsers, setListOfUsers] = useState()
    const [listOfRoles, setListOfRoles] = useState<Ruolo[]>([])
    const [userToRemove, setUserToRemove] = useState<number>(0)
    const [removeModal, setRemoveModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [editingUser, setEditingUser] = useState<Utente | null>(null)
    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
        },
        {
            title: "Cognome",
            dataIndex: "cognome",
            key: "cognome",
        },
        {
            title: "Email",
            dataIndex: "email",
            key: "email",
        },
        {
            title: "Ruolo",
            key: "ruolo",
            render: (record: any) => record.ruolo.descrizione
        },
        {
            title: "Azioni",
            key: "actions",
            render: (record: Utente) => (
                <span>
                <Button
                    className={"margin-right"}
                    icon={<EditOutlined/>}
                    type={"primary"}
                    onClick={() => {
                        setEditingUser(record);
                        form.setFieldsValue({
                            name: record.nome,
                            lastname: record.cognome,
                            email: record.email,
                            roleId: record.ruolo?.id,
                        });
                        setModalOpen(true);
                    }}
                />
                    <Button
                        icon={<DeleteOutlined/>}
                        danger
                        onClick={() => {
                            setUserToRemove(record.id)
                            setRemoveModal(true)
                        }}
                    />

                    </span>
            )
        }

    ];
    const [form] = Form.useForm();

    const addOrUpdateUser = async () => {
        try {
            const values = form.getFieldsValue();
            const requestBody = {
                id: editingUser?.id,
                email: values.email,
                name: values.name,
                lastname: values.lastname,
                roleId: values.roleId,
            };

            if (!editingUser) {
                await HttpService.getInstanceAxios().post('/user/save', requestBody);
            } else if (editingUser) {
                await HttpService.getInstanceAxios().post('/user/update', requestBody);
            }

            message.success(editingUser ? "Utente modificato con successo" : "Utente aggiunto con successo");
            await fetchListOfUsers()
            setModalOpen(false);
            setEditingUser(null);
            form.resetFields();
        } catch (error) {
            HttpErrorService.handle("Errore durante il salvataggio utente", error, true);
        }
    }
    const deleteUser = async (userId: number) => {
        try {
            await HttpService.getInstanceAxios().get(`/user/delete/${userId}`);
            message.success("Utente rimosso con successo")
            await fetchListOfUsers()
            setRemoveModal(false)
        } catch (error) {
            HttpErrorService.handle("Errore durante la cancellazione dell'utente", error, true);
        }
    }
    const fetchListOfUsers = async () => {
        try {
            const requestPage: SpringPageable = {
                page: 0,
                size: 100
            }
            const data = await HttpService.getInstanceAxios().get('/user', {
                params: requestPage
            })
            setListOfUsers(data.data.content)

        } catch (error) {
            HttpErrorService.handle("Errore durante il recupero dei codici esenzione", error, true)
        }
    }

    useEffect(() => {
        fetchListOfUsers()
    }, []);

    useEffect(() => {
        const fetchListOfRoles = async () => {
            try {
                const data = await HttpService.getInstanceAxios().get('/role/list')
                setListOfRoles(data.data.data)
            } catch (error) {
                HttpErrorService.handle("Errore durante il recupero dei ruoli", error, true)
            }
        }
        fetchListOfRoles()
    }, []);

    return (
        <>
            <Table<Utente>
                dataSource={listOfUsers}
                columns={columns}
            >
            </Table>
            <div style={{display: "flex", justifyContent: "flex-end"}}>
                <Button
                    icon={<PlusOutlined/>}
                    type="primary"
                    onClick={() => {
                        setEditingUser(null);
                        form.resetFields();
                        setModalOpen(true);
                    }}
                >
                    Aggiungi utente
                </Button>

            </div>
            <Modal
                title={editingUser ? "Modifica utente" : "Aggiungi utente"}
                open={modalOpen}
                onCancel={() => {
                    setModalOpen(false);
                    setEditingUser(null);
                    form.resetFields();
                }}
                footer={false}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={addOrUpdateUser}
                >
                    <Form.Item label="Nome" name="name" rules={[{required: true, message: "Inserisci il nome"}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item label="Cognome" name="lastname"
                               rules={[{required: true, message: "Inserisci il cognome"}]}>
                        <Input/>
                    </Form.Item>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            {required: true, message: "Inserisci l'email"},
                            {type: "email", message: "Inserisci un'email valida"},
                        ]}
                    >
                        <Input disabled={!!editingUser}/>
                    </Form.Item>
                    <Form.Item label="Ruolo" name="roleId" rules={[{required: true, message: "Seleziona un ruolo"}]}>
                        <Select placeholder="Seleziona ruolo">
                            {listOfRoles.map((role) => (
                                <Select.Option key={role.id} value={role.id}>
                                    {role.descrizione}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Space style={{display: "flex", justifyContent: "flex-end"}}>
                        <Button onClick={() => {
                            form.resetFields();
                            setModalOpen(false);
                            setEditingUser(null);
                        }}>
                            Annulla
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {editingUser ? "Salva modifiche" : "Aggiungi"}
                        </Button>
                    </Space>
                </Form>
            </Modal>
            <ConfirmModal
                visible={removeModal}
                onConfirm={() => deleteUser(userToRemove)}
                onCancel={() => setRemoveModal(false)}
                title="Elimina utente"
                message="Sei sicuro di voler eliminare questo utente?"
                confirmText="Sì, elimina"
                cancelText="Annulla"
            />
        </>
    )
}
